module.exports = __webpack_public_path__ + "static/img/doctor.46b10636.svg";